export enum ExchangeInformationType {
  AccountAccumulation = 1,
  None = 2,
  BankSavings = 3,
}
